import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditPartnerForm} from '../../model';
import {PartnerModel} from '../../../../entities';

interface EditPartnerModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  partnerId: string;
  partner: PartnerModel | null;
}

export const EditPartnerModal = ({open, setOpen, partnerId, partner}: EditPartnerModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditPartnerForm({partnerId, partner, setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Партнер',
    title: 'Ошибка при редактировании партнера',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Сбрасываем форму при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать партнера'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Название"
          placeholder="Название партнера"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />
        <FormInput
          label="Описание"
          placeholder="Описание партнера"
          name="description"
          value={values.description || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          isTextarea
          rows={3}
          error={touched.description && errors.description}
        />
        <FormInput
          label="Приоритет"
          placeholder="1"
          name="priority"
          type="number"
          value={values.priority.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.priority && errors.priority}
        />
        <FormInput
          label="Сайт"
          placeholder="https://example.com"
          name="website"
          value={values.website || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.website && errors.website}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
